import { DropdownOption } from '@ihsm/ui-shared';
import {
  Header,
  JobAll,
  JobAnyDate,
  JobItemStatus,
  JobItemType,
} from '../types';

export const NOW: number = new Date().getTime();

export const DAY = 86400000; // Day in MS -> 1000 * 60 * 60 * 24;

export const HOUR = 3600000; // Hour in MS -> 1000 * 60 * 60;

export const TODAY_TIME_VALUE: number = new Date().getTime() - DAY;

export const YESTERDAY_TIME_VALUE: number = new Date().getTime() - DAY * 2;

export const JOB_REPORT_TYPES: (JobItemType | JobAll)[] = [
  'All',
  'Custom',
  'SEC 18F-4',
  'UCITS',
  'AIFMD',
];

export const JOB_VALUE_ALL: JobAll = 'All';

export const JOB_ANY_DATE: JobAnyDate = 'Any Date';

export const JOB_STATUS_RUNNING: JobItemStatus = 'Running';

export const JOB_STATUS_COMPLETED: JobItemStatus = 'Completed';

export const JOB_STATUS_FAILED: JobItemStatus = 'Failed';

export const JOB_STATUS: (JobItemStatus | JobAll)[] = [
  JOB_VALUE_ALL,
  JOB_STATUS_RUNNING,
  JOB_STATUS_COMPLETED,
  JOB_STATUS_FAILED,
];

export const JOB_HEADER_COLUMNS: Header[] = [
  { title: 'Name', span: 3 },
  { title: 'Report Type' },
  { title: 'Valuation Date', span: 2 },
  { title: 'Started', span: 2 },
  { title: 'Duration' },
  { title: 'Status', span: 2 },
];

export const VIEW_CONFIGURATION = 'view_configuration';

export const VIEW_LOG = 'view_log';

export const RERUN_JOB = 'rerun_job';

export const JOB_DROPDOWN_OPTIONS: DropdownOption[] = [
  { displayText: 'View Configuration', value: VIEW_CONFIGURATION },
  { displayText: 'View Log', value: VIEW_LOG },
  { displayText: 'Re-run Job', value: RERUN_JOB },
];
